import { Button } from 'antd';

import { Arrow } from '../../../Common/Icon';

import styles from './index.module.scss';

//import VideoEmpty from '../../../Common/Video/Empty';
import { useNavigate } from 'react-router-dom';
import Video from '../../../Common/Video';

function WhatIsTippingGuide() {
  const navigate = useNavigate();
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.innerWrapper}>
            <h2 className={styles.title}>
              <span>What is</span>
              <span className="colorGreen">Tipping Guide</span>
            </h2>
            <p className={styles.description}>
              A community designed to empower Americans to shape tipping
              culture, share their experiences, and tip with confidence!
            </p>

            <div>
              <Button
                icon={<Arrow />}
                type="primary"
                size="large"
                className={styles.button}
                onClick={() => navigate('/our-mission')}
              >
                Learn more
              </Button>
            </div>
          </div>
          <Video
            src={'/TippingGuide.mp4'}
            poster={'/media/whatIsTippingGuide.png'}
          />
          {/* <VideoEmpty /> */}
        </div>
      </div>
    </div>
  );
}

export default WhatIsTippingGuide;
